import * as React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { CardWithHeader } from "@/components/card-with-header";

export const Route = createFileRoute("/about")({
  component: AboutComponent,
});

function AboutComponent() {
  return (
    <div className="container max-w-3xl py-6">
      <CardWithHeader
        variant="exchange"
        label="Volume Merchant Portal"
        title="About"
        fullHeight={false}
      >
        <p className="text-sm text-V_Base90">
          Volume Merchant Portal lets you manage payments, balances, and
          settings for your Volume account.
        </p>
      </CardWithHeader>
    </div>
  );
}
